function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.62797 0.921962C9.86258 0.804659 10.1387 0.804659 10.3733 0.921962L18.7067 5.08863C18.989 5.22979 19.1673 5.51834 19.1673 5.83398C19.1673 6.14963 18.989 6.43818 18.7067 6.57934L10.3733 10.746C10.1387 10.8633 9.86258 10.8633 9.62797 10.746L1.29464 6.57934C1.01232 6.43818 0.833984 6.14963 0.833984 5.83398C0.833984 5.51834 1.01232 5.22979 1.29464 5.08863L9.62797 0.921962ZM3.53071 5.83398L10.0007 9.06896L16.4706 5.83398L10.0007 2.59901L3.53071 5.83398Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.922144 13.7948C1.12797 13.3832 1.62853 13.2163 2.04018 13.4221L10.0008 17.4025L17.9615 13.4221C18.3731 13.2163 18.8737 13.3832 19.0795 13.7948C19.2853 14.2065 19.1185 14.707 18.7068 14.9129L10.3735 19.0795C10.1389 19.1968 9.86276 19.1968 9.62816 19.0795L1.29482 14.9129C0.883174 14.707 0.71632 14.2065 0.922144 13.7948Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.922144 9.62685C1.12797 9.2152 1.62853 9.04835 2.04018 9.25418L10.0008 13.2345L17.9615 9.25418C18.3731 9.04835 18.8737 9.2152 19.0795 9.62685C19.2853 10.0385 19.1185 10.5391 18.7068 10.7449L10.3735 14.9116C10.1389 15.0289 9.86276 15.0289 9.62816 14.9116L1.29482 10.7449C0.883174 10.5391 0.71632 10.0385 0.922144 9.62685Z"
});

var SvgLayers = function SvgLayers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layers.abad086f.svg";
export { ForwardRef as ReactComponent };